import axios from "axios";

export const axiosRequest = axios.create({
  baseURL: `${process.env.REACT_APP_ORKESTAMEDIA_API}/api/v1`,
});